<template>
  <div class="accordion">
    <h4 class="use-text-subtitle mb-3">
      {{ faq.header }}
    </h4>
    <v-expansion-panels v-model="panel" active-class="expanded">
      <v-expansion-panel v-for="(item, index) in faq.items" :key="index" class="paper">
        <v-expansion-panel-header class="content">
          <span class="heading">
            {{ item.q }}
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="detail">
          <pre>{{ item.a }}</pre>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<style lang="scss" scoped>
@import './faq-style.scss';
pre {
  white-space: break-spaces;
  font-family: none;
}
</style>

<script>
export default {
  data() {
    return {
      panel: -1,
    }
  },
  props: {
    faq: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    isMobile() {
      const smDown = this.$store.state.breakpoints.smDown
      return smDown.indexOf(this.$mq) > -1
    }
  }
}
</script>
